export default "__VITE_ASSET__c750b6c0__"